var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen overflow-hidden",staticStyle:{"overflow":"hidden !important","max-width":"100vw","max-height":"100vh"},attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }